export const STORE_TOKEN = "STORE_TOKEN";
export const DELETE_TOKEN = "DELETE_TOKEN";
export const SET_CURRENT_PROFILE = "SET_CURRENT_PROFILE";
export const SET_LOGGEDIN_USER = "SET_LOGGEDIN_USER";
export const SET_CURRENT_POST = "SET_CURRENT_POST";